(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core')) :
	typeof define === 'function' && define.amd ? define(['exports', '@angular/core'], factory) :
	(factory((global['ngx-parallax'] = {}),global.core));
}(this, (function (exports,core) { 'use strict';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */







function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}



function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

// ngx-parallax
var Parallax = /** @class */ (function () {
    function Parallax(element) {
        var _this = this;
        this.name = 'parallaxDirective';
        // the following @Inputs are all part of the config object, which for 
        // brevity's sake, you can do a bunch of operations in bulk by passing 
        // in the config object; caveat for this is that angular 2 won't permit 
        // more than 9 keys being passed in an object via the template
        this.cssKey = 'backgroundPosition';
        this.cssProperty = 'backgroundPositionY';
        this.axis = 'Y';
        this.ratio = -.7;
        this.initialValue = 0;
        this.canMove = true;
        this.cssUnit = 'px';
        this.cb_context = null;
        this.cb_args = [];
        this.parallaxStyles = {};
        this.isSpecialVal = false;
        this.evaluateScroll = function () {
            if (_this.canMove) {
                var resultVal = void 0;
                var calcVal = void 0;
                if (_this.scrollElement instanceof Window)
                    calcVal = _this.scrollElement.scrollY * _this.ratio + _this.initialValue;
                else
                    calcVal = _this.scrollElement.scrollTop * _this.ratio + _this.initialValue;
                if (_this.maxValue !== undefined && calcVal >= _this.maxValue)
                    calcVal = _this.maxValue;
                else if (_this.minValue !== undefined && calcVal <= _this.minValue)
                    calcVal = _this.minValue;
                // added after realizing original setup wasn't compatible in Firefox
                // debugger;
                if (_this.cssKey === 'backgroundPosition') {
                    if (_this.axis === 'X') {
                        resultVal = 'calc(50% + ' + calcVal + _this.cssUnit + ') center';
                    }
                    else {
                        resultVal = 'center calc(50% + ' + calcVal + _this.cssUnit + ')';
                    }
                }
                else if (_this.isSpecialVal) {
                    resultVal = _this.cssValue + '(' + calcVal + _this.cssUnit + ')';
                }
                else {
                    resultVal = calcVal + _this.cssUnit;
                }
                if (_this.cb) {
                    // console.log('this should be running')
                    _this.cb.apply(_this.cb_context, _this.cb_args);
                }
                _this.parallaxElement.style[_this.cssKey] = resultVal;
            }
        };
        this.hostElement = element.nativeElement;
    }
    Parallax.prototype.ngOnInit = function () {
        var cssValArray;
        // console.log('%s initialized on element', this.name, this.hostElement);
        // console.log(this);
        for (var prop in this.config) {
            this[prop] = this.config[prop];
        }
        this.cssProperty = this.cssProperty ? this.cssProperty : 'backgroundPositionY';
        if (this.cssProperty.match(/backgroundPosition/i)) {
            if (this.cssProperty.split('backgroundPosition')[1].toUpperCase() === 'X') {
                this.axis = 'X';
            }
            this.cssProperty = 'backgroundPosition';
        }
        cssValArray = this.cssProperty.split(':');
        this.cssKey = cssValArray[0];
        this.cssValue = cssValArray[1];
        this.isSpecialVal = this.cssValue ? true : false;
        if (!this.cssValue)
            this.cssValue = this.cssKey;
        this.ratio = +this.ratio;
        this.initialValue = +this.initialValue;
        this.parallaxElement = this.parallaxElement || this.hostElement;
        if (!this.scrollElement) {
            if (document.getElementById('parallaxScroll'))
                this.scrollElement = document.getElementById('parallaxScroll');
            else if (this.scrollerId) {
                try {
                    this.scrollElement = document.getElementById(this.scrollerId);
                    if (!this.scrollElement)
                        throw ("The ID passed through the parallaxConfig ('" + this.scrollerId + "') object was not found in the document.  Defaulting to tracking the scrolling of the window.");
                }
                catch (e) {
                    console.warn(e);
                    this.scrollElement = window;
                }
            }
            else
                this.scrollElement = window;
        }
        this.evaluateScroll();
        this.scrollElement.addEventListener('scroll', this.evaluateScroll.bind(this));
    };
    __decorate([
        core.Input(),
        __metadata("design:type", Object)
    ], Parallax.prototype, "config", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", String)
    ], Parallax.prototype, "cssKey", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", String)
    ], Parallax.prototype, "cssProperty", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", String)
    ], Parallax.prototype, "axis", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", Number)
    ], Parallax.prototype, "ratio", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", Number)
    ], Parallax.prototype, "initialValue", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", Object)
    ], Parallax.prototype, "canMove", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", String)
    ], Parallax.prototype, "scrollerId", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", Number)
    ], Parallax.prototype, "maxValue", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", Number)
    ], Parallax.prototype, "minValue", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", String)
    ], Parallax.prototype, "cssUnit", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", Object)
    ], Parallax.prototype, "cb", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", Object)
    ], Parallax.prototype, "cb_context", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", Array)
    ], Parallax.prototype, "cb_args", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", Object)
    ], Parallax.prototype, "scrollElement", void 0);
    __decorate([
        core.Input(),
        __metadata("design:type", Object)
    ], Parallax.prototype, "parallaxElement", void 0);
    Parallax = __decorate([
        core.Directive({
            selector: '[parallax]'
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof core.ElementRef !== "undefined" && core.ElementRef) === "function" && _a || Object])
    ], Parallax);
    return Parallax;
    var _a;
}());

var ParallaxModule = /** @class */ (function () {
    function ParallaxModule() {
    }
    ParallaxModule_1 = ParallaxModule;
    ParallaxModule.forRoot = function () {
        return {
            ngModule: ParallaxModule_1,
            providers: []
        };
    };
    ParallaxModule = ParallaxModule_1 = __decorate([
        core.NgModule({
            declarations: [
                Parallax
            ],
            exports: [
                Parallax
            ]
        })
    ], ParallaxModule);
    return ParallaxModule;
    var ParallaxModule_1;
}());

exports.Parallax = Parallax;
exports.ParallaxModule = ParallaxModule;

Object.defineProperty(exports, '__esModule', { value: true });

})));
